import { createFeature, createReducer, on } from '@ngrx/store';
import { User } from '../../services/model/user';
import { ProfileActions } from '../actions/profile.actions';

export interface ProfileState {
  profiles: User[] | null;
}

export const initialProfileState: ProfileState = {
  profiles: null,
};

export const profileFeature = createFeature({
  name: 'profile',
  reducer: createReducer(
    initialProfileState,
    on(ProfileActions.profilesLoaded, (state, { profiles }) => ({
      ...state,
      profiles,
    })),
  ),
});
